export default __webpack_public_path__ + "static/bus-accidents-9c02add3ca7f14cceff6ac57bb82a56c.jpg";